import FrontEndApi from '../../../../Common/Globals/Scripts/FrontEndApi';

async function submitCsvImport(file, apiFunctionName) {
    try
    {
        await FrontEndApi[apiFunctionName](file);
        return [];
    }
    catch(exception)
    {
        const response = exception.responseObject;
        if(response && response.errorType === 'ValidationFailed') {
            return response.errorDetails;
        }
        throw exception;
    }
}

export default { submitCsvImport }
